import appConfig from "configs/app.config";
import { invokeOmsService } from "./apiService";
import { buildQueryParams } from "../utils/helper";

const createDocument = (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.createDocument,
    body,
  };
  return invokeOmsService(requestParams);
};

const getCustomerData = (payload) => {
  const queryString = buildQueryParams(payload, {
    type: "doctorfacility",
    inputValue: "",
  });
  const url = `${appConfig.v2.getCustomerData}?${queryString}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return invokeOmsService(requestParams);
};

const getFacilityList = (type, filter) => {
  const queryString = buildQueryParams(filter, {
    pageNumber: 1,
    search: "",
  });
  const url = `${appConfig.v2.organizations.getOrganizationsByType.replace("{type}", type)}${queryString ? `?${queryString}` : ""}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return invokeOmsService(requestParams);
};

const fetchServiceTypes = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getServiceTypes,
  };
  return await invokeOmsService(requestParams);
};

const getRecordTypesByOrgId = async (orgId, filter) => {
  const queryString = buildQueryParams(filter, {
    type: "MEDICAL_FACILITY",
    perPage: 200,
  });
  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.recordTypes.getRecordTypesByOrgId.replace("{orgId}", orgId)}${queryString ? `?${queryString}` : ""}`,
  };
  return await invokeOmsService(requestParams);
};

// Record types from the organization's Active package billing for a request type.
const getPackageRecordTypesByOrgId = async (orgId, filter) => {
  const queryString = buildQueryParams(filter, {});
  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.packageRecordTypesByOrgId.replace("{orgId}", orgId)}${queryString ? `?${queryString}` : ""}`,
  };
  return await invokeOmsService(requestParams);
};

const getRequestTypeByOrgId = async (orgId, filter) => {
  const queryString = buildQueryParams(filter, {
    type: "PATIENT",
    nature: "MEDICAL_FACILITY",
    perPage: 200,
  });
  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.requestTypes.getRequestTypesByOrgId.replace("{orgId}", orgId)}${queryString ? `?${queryString}` : ""}`,
  };
  return await invokeOmsService(requestParams);
};

const getAllRecordTypesByOrgId = async (orgId, payload = {}) => {
  const {
    pageNumber = 1,
    perPage = 10,
    sortBy = "createdAt",
    sortOrder = "desc",
  } = payload;
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.recordTypes.getRecordTypesByOrgId.replace("{orgId}", orgId) +
      `?pageNumber=${pageNumber}&perPage=${perPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
  };
  return await invokeOmsService(requestParams);
};

const getAccountDetailsbyOrgId = async (orgId) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.accounts.getAccountDetailsByOrgId.replace(
      "{orgId}",
      orgId,
    ),
  };
  return await invokeOmsService(requestParams);
};

const fetchConfigurationByOrgId = async (orgId) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.configuration.getConfigurationByOrgId.replace(
      "{orgId}",
      orgId,
    ),
  };
  return await invokeOmsService(requestParams);
};

const saveService = async (payload) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.saveService,
    body: payload,
  };
  return await invokeOmsService(requestParams);
};

const updateServiceDraft = async (id, payload) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.updateServiceDraft.replace(
      "{orderDraftId}",
      id,
    ),
    body: payload,
  };
  return await invokeOmsService(requestParams);
};

const saveApplicant = async (payload) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.saveApplicant.replace(
      "{orderDraftId}",
      payload.orderDraftId,
    ),
    body: payload,
  };
  return await invokeOmsService(requestParams);
};

const updateApplicantDraft = async (
  orderDraftId,
  applicantDraftId,
  payload,
) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.updateApplicantDraft
      .replace("{orderDraftId}", orderDraftId)
      .replace("{id}", applicantDraftId),
    body: payload,
  };
  return await invokeOmsService(requestParams);
};

const saveUploads = async (orderDraftId, payload) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.saveUploads.replace(
      "{orderDraftId}",
      orderDraftId,
    ),
    body: payload,
  };
  return await invokeOmsService(requestParams);
};

const saveManualOrderUploads = async (orderDraftId, payload) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.saveManualOrderUploads.replace(
      "{orderDraftId}",
      orderDraftId,
    ),
    body: payload,
  };
  return await invokeOmsService(requestParams);
};

const getOrderDetails = async (orderIds) => {
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.documentRequest.getOrderDetails +
      `?orderIds=${orderIds.join(",")}`,
  };
  return await invokeOmsService(requestParams);
};

const getOrganizationById = async (orgId) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.organizations.getOrganizationDetailswithAddress.replace(
      "{id}",
      orgId,
    ),
  };
  return await invokeOmsService(requestParams);
};

const getUploadEnums = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.uploads.getFileEnums,
  };
  return await invokeOmsService(requestParams);
};

const getAuditTypes = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getAuditEnums,
  };
  return await invokeOmsService(requestParams);
};

const getOrderDraftById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getOrderDraftById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getOrderSummaryById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getOrderSummaryById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const createInvoiceByOrderDraftId = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.createInvoicebyOrderDraft,
    body: body,
  };
  return await invokeOmsService(requestParams);
};

const createInvoiceByOrderId = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.createInvoicebyOrder,
    body: body,
  };
  return await invokeOmsService(requestParams);
};

const getOrderDetailsRequestProcessor = async (orderId) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getOrderDetailsRequestProcessor.replace(
      "{orderId}",
      orderId,
    ),
  };
  return await invokeOmsService(requestParams);
};

const getOrderStatusLogsById = async (orderId, category) => {
  const url = appConfig.v2.documentRequest.getOrderStatusLogsById.replace(
    "{orderId}",
    orderId,
  );

  const requestParams = {
    method: "GET",
    url: category ? `${url}?category=${category}` : url,
  };
  return await invokeOmsService(requestParams);
};

const getRequestInternalStatusEnums = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getRequestInternalStatusEnums,
  };
  return await invokeOmsService(requestParams);
};

const getFacilityDetailsByAccountId = async (accountId) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getFacilityDetailsByAccountId.replace(
      "{id}",
      accountId,
    ),
  };
  return await invokeOmsService(requestParams);
};

const getPatientDetailsById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getPatientDetailsById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getOrderById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getOrderById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getInvoicesByOrderId = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getInvoicesByOrderId.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getUserProfileById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getUserProfileById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const updateOrderStatus = async (data) => {
  const requestParams = {
    method: "PUT",
    body: data,
    url: appConfig.v2.documentRequest.updateOrderStatus,
  };
  return await invokeOmsService(requestParams);
};

const getSasTokenOrder = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.uploads.getSasTokenOrder,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getSasTokenBulk = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.uploads.getSasTokenBulk,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getInvoiceById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getInvoiceById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getrecordPaymentById = async (orderId) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getrecordPaymentById.replace(
      "{orderId}",
      orderId,
    ),
  };
  return await invokeOmsService(requestParams);
};

const getStripeAccountDetailsById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getStripeAccountDetailsById.replace(
      "{id}",
      id,
    ),
  };
  return await invokeOmsService(requestParams);
};
const createOrderFiles = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.uploads.createFiles,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const generatePDF = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.uploads.generatePDF.replace("{id}", id),
    body,
    // Dev Event Grid can run fileHandler synchronously; default 60s axios timeout aborts early.
    timeout: 10 * 60 * 1000,
  };
  return await invokeOmsService(requestParams);
};

const updateOrder = async (id, requestBody) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.updateOrder.replace("{id}", id),
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const updateOrderRequesterDetails = async (id, requestBody) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.updateOrderRequesterDetails.replace(
      "{id}",
      id,
    ),
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const updateFacility = async (id, requestBody) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.updateFacility.replace("{id}", id),
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const updatePatientDetails = async (id, requestBody) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.updatePatientDetails.replace("{id}", id),
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const updateUserProfile = async (id, requestBody) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.updateUserProfile.replace("{id}", id),
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getFilesView = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.uploads.getFilesView,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const recordPayment = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.recordPayment,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getRequesterCountsByStatus = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getRequesterCountsByStatus,
  };
  return await invokeOmsService(requestParams);
};

const getRequestProcessorCountsByStatus = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getRequestProcessorCountByStatus,
  };
  return await invokeOmsService(requestParams);
};

const getInvoiceByOrderId = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getrecordPaymentById.replace(
      "{orderId}",
      id,
    ),
  };
  return await invokeOmsService(requestParams);
};

const deleteFile = async (orderId, id) => {
  const requestParams = {
    method: "STRICT_DELETE",
    url: appConfig.v2.documentRequest.deleteOrderfiles
      .replace("{id}", id)
      .replace("{orderId}", orderId),
  };
  return await invokeOmsService(requestParams);
};

const deleteFiles = async (orderId, fileIds) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.bulkDeleteOrderFiles.replace(
      "{orderId}",
      orderId,
    ),
    body: { fileIds },
  };
  return await invokeOmsService(requestParams);
};
const getOrdersbyDraftId = async (id, payload = {}) => {
  const {
    pageNumber = 1,
    perPage = 10,
    sortBy = "createdAt",
    sortOrder = "desc",
  } = payload;
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.documentRequest.getOrdersbyDraftId.replace("{id}", id) +
      `?pageNumber=${pageNumber}&perPage=${perPage}&sortBy=${sortBy}&orderBy=${sortOrder}`,
  };
  return await invokeOmsService(requestParams);
};

const getOrderDraftIdDetails = async (orderDraftId) => {
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.documentRequest.getOrderDraftIdDetails.replace("{orderDraftId}", orderDraftId),
  };
  return await invokeOmsService(requestParams);
};

const getOrderPaymentSummary = async (orderId, paymentType = "advance") => {
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.documentRequest.getOrderPaymentSummary.replace(
        "{orderId}",
        orderId,
      ) + `?type=${paymentType}`,
  };
  return await invokeOmsService(requestParams);
};

const checkNewRequestEligibility = async ({
  requesterAccountId,
  requestProcessorAccountId,
  requestProcessorOrganizationId,
} = {}) => {
  const params = new URLSearchParams();
  if (requesterAccountId != null && requesterAccountId !== "") {
    params.set("requesterAccountId", String(requesterAccountId));
  }
  if (requestProcessorAccountId != null && requestProcessorAccountId !== "") {
    params.set("requestProcessorAccountId", String(requestProcessorAccountId));
  }
  if (
    requestProcessorOrganizationId != null &&
    requestProcessorOrganizationId !== ""
  ) {
    params.set(
      "requestProcessorOrganizationId",
      String(requestProcessorOrganizationId),
    );
  }
  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.documentRequest.checkNewRequestEligibility}?${params.toString()}`,
  };
  return await invokeOmsService(requestParams);
};

const getCheckRemittance = async (
  id,
  { paymentType = "advance", existingOrder = false } = {}
) => {
  const params = new URLSearchParams({
    type: paymentType,
    existingOrder: existingOrder ? "true" : "false",
  });
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.documentRequest.getCheckRemittance.replace("{id}", id) +
      `?${params.toString()}`,
  };
  return await invokeOmsService(requestParams);
};

const confirmOrderDraftPayment = async (orderDraftId, body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.confirmOrderDraftPayment.replace(
      "{orderDraftId}",
      orderDraftId,
    ),
    body,
  };
  return await invokeOmsService(requestParams);
};

const createOrdersFromDraft = async (orderDraftId) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.createOrdersFromDraft.replace(
      "{orderDraftId}",
      orderDraftId,
    ),
  };
  return await invokeOmsService(requestParams);
};

const createNotes = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.createNotes,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getNotes = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getNotes.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const updateRejectedOrderDetails = async (id, requestBody) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.updateRejectedOrderDetails.replace(
      "{id}",
      id,
    ),
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const updateRejectedOrderFiles = async (id, requestBody) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.updateRejectedOrderFiles.replace(
      "{id}",
      id,
    ),
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const deleteGeneratePdf = async (id) => {
  const requestParams = {
    method: "STRICT_DELETE",
    url: appConfig.v2.documentRequest.deleteGeneratePdf.replace(
      "{orderId}",
      id,
    ),
  };
  return await invokeOmsService(requestParams);
};

const getbulkAssignmentEnums = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getBulkAssignmentEnums,
  };
  return await invokeOmsService(requestParams);
};

const bulkAssignment = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.bulkAssignment,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const passwordCheck = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.passwordCheck,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getRequesterFiles = async (requestBody, id) => {
  const { pageIndex, pageSize, sortBy, sortOrder } = requestBody;
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.getRequesterFiles.replace("{orderId}", id) +
      `?pageNumber=${
        pageIndex
      }&perPage=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
  };
  return await invokeOmsService(requestParams);
};

const getRequesterProcessorFiles = async (requestBody, id) => {
  const { pageIndex, pageSize, sortBy, sortOrder } = requestBody;
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.getRequestProcessorFiles.replace("{orderId}", id) +
      `?pageNumber=${
        pageIndex
      }&perPage=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
  };
  return await invokeOmsService(requestParams);
};

const createFileTaskLogs = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.bulkuploads.createfilesbulkTask,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getFilterData = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.bulkuploads.getFilterData,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getfileProcessingTasks = async (requestBody) => {
  const { pageIndex, pageSize, sortBy, sortOrder, search } = requestBody;
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.bulkuploads.getAllfilesbulkTask +
      `?pageNumber=${
        pageIndex
      }&perPage=${pageSize}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`,
  };
  return await invokeOmsService(requestParams);
};

const getXrayFiles = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getXrayFiles.replace("{orderId}", id),
  };
  return await invokeOmsService(requestParams);
};

const bulkEmailInvoice = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.bulkEmailInvoice,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const bulkSendInvoiceVia = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.bulkSendInvoiceVia,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const downloadFile = async (id, orderId, firstDownload = false) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.downloadFile
      .replace("{id}", id)
      .replace("{orderId}", orderId) +
      `?firstDownload=${firstDownload}`,
  };
  return await invokeOmsService(requestParams);
};

const otpRequestDownloadFile = async (orderId, fileId) => {
  const url = appConfig.v2.documentRequest.otpRequestDownloadFile
    .replace("{orderId}", orderId)
    .replace("{fileId}", fileId);

  const requestParams = {
    method: "POST",
    url,
  };

  return await invokeOmsService(requestParams);
};
const resendOtpRequestDocument = async (orderId, fileId) => {
  const url = appConfig.v2.documentRequest.resendOtpRequestDocument
    .replace("{orderId}", orderId)
    .replace("{fileId}", fileId);

  const requestParams = {
    method: "POST",
    url,
  };

  return await invokeOmsService(requestParams);
};

const downloadFileWithOtp = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.downloadFileWithOtp,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
}

const downloadOtpLog = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.downloadOtpLog,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
}

const getRequesterTicketsCounts = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getRequesterTicketsCounts,
  };
  return await invokeOmsService(requestParams);
};

const getRequestProcessorTicketsCounts = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getProcessorTicketsCounts,
  };
  return await invokeOmsService(requestParams);
};

const getReminder = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getReminder,
  };
  return await invokeOmsService(requestParams);
};

const updateReminder = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.updateReminder.replace("{id}", id),
    body,
  };

  return await invokeOmsService(requestParams);
};

const skipAdvanceFee = async (id) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.skipAdvanceFee.replace("{orderId}", id),
  };
  return await invokeOmsService(requestParams);
};

const revertRejectedOrder = async (id) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.revertRejectedOrder.replace(
      "{orderId}",
      id,
    ),
  };
  return await invokeOmsService(requestParams);
};

const revertCancelledOrder = async (id) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.revertCancelledOrder.replace(
      "{orderId}",
      id,
    ),
  };
  return await invokeOmsService(requestParams);
};

const nextOrder = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.nextOrder,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const requesterNextOrder = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.requesterNextOrder,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const previousOrder = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.previousOrder,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const requesterPreviousOrder = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.requesterPreviousOrder,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getAllOrganizationsByAccountId = async (data, accountId) => {
  const { perPage, pageNumber, sortBy, sortOrder, search } = data;

  let url =
    appConfig.v2.accounts.getAllOrganizationsByAccountId.replace(
      "{accountId}",
      accountId,
    ) +
    `?pageNumber=${pageNumber}&perPage=${perPage}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await invokeOmsService(requestParams);
};

const searchRequests = async (params) => {
  const queryString = buildQueryParams(params, {});
  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.search}?${queryString}`,
  };
  return await invokeOmsService(requestParams);
};

const removeFee = async (orderId, invoiceId, feeId, message) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.documentRequest.removeFee.replace("{orderId}", orderId).replace("{invoiceId}", invoiceId).replace("{feeId}", feeId),
    body: {
      message,
    }
  };
  return await invokeOmsService(requestParams);
}

const checkDuplicateFiles = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.uploads.checkDuplicates,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const updateOrderFile = async (id, requestBody) => {
  const requestParams = {
    method: "PUT",
    url: `${appConfig.v2.uploads.createFiles}/${id}`,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getDraftDetails = async (draftId) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.documentRequest.getDraftDetails.replace("{draftId}", draftId),
  };
  return await invokeOmsService(requestParams);
};

const bulkSendFax = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.documentRequest.bulkSendFax,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const DocumentRequestService = {
  getDraftDetails,
  updateOrderFile,
  checkDuplicateFiles,
  getAllOrganizationsByAccountId,
  getbulkAssignmentEnums,
  bulkAssignment,
  getOrdersbyDraftId,
  createDocument,
  getCustomerData,
  getFacilityList,
  getRecordTypesByOrgId,
  getPackageRecordTypesByOrgId,
  getRequestTypeByOrgId,
  getAccountDetailsbyOrgId,
  fetchConfigurationByOrgId,
  saveService,
  updateServiceDraft,
  saveApplicant,
  updateApplicantDraft,
  saveUploads,
  saveManualOrderUploads,
  fetchServiceTypes,
  getOrderDetails,
  getOrganizationById,
  getUserProfileById,
  getUploadEnums,
  getAuditTypes,
  getPatientDetailsById,
  getInvoicesByOrderId,
  getFacilityDetailsByAccountId,
  getOrderById,
  updateFacility,
  updatePatientDetails,
  updateUserProfile,
  getOrderDraftById,
  getOrderStatusLogsById,
  getAllRecordTypesByOrgId,
  getOrderSummaryById,
  createInvoiceByOrderDraftId,
  createInvoiceByOrderId,
  getOrderDetailsRequestProcessor,
  getRequestInternalStatusEnums,
  getStripeAccountDetailsById,
  updateOrderStatus,
  getSasTokenOrder,
  getrecordPaymentById,
  getInvoiceById,
  createOrderFiles,
  recordPayment,
  generatePDF,
  requesterNextOrder,
  requesterPreviousOrder,
  updateOrder,
  updateOrderRequesterDetails,
  getFilesView,
  getRequesterCountsByStatus,
  getRequestProcessorCountsByStatus,
  getInvoiceByOrderId,
  deleteFile,
  deleteFiles,
  createNotes,
  getNotes,
  updateRejectedOrderFiles,
  updateRejectedOrderDetails,
  deleteGeneratePdf,
  passwordCheck,
  getRequesterFiles,
  getRequesterProcessorFiles,
  getSasTokenBulk,
  downloadFile,
  otpRequestDownloadFile,
  resendOtpRequestDocument,
  downloadFileWithOtp,
  downloadOtpLog,
  createFileTaskLogs,
  getfileProcessingTasks,
  getXrayFiles,
  revertRejectedOrder,
  getFilterData,
  bulkEmailInvoice,
  bulkSendInvoiceVia,
  getRequesterTicketsCounts,
  getRequestProcessorTicketsCounts,
  getReminder,
  updateReminder,
  skipAdvanceFee,
  revertCancelledOrder,
  nextOrder,
  previousOrder,
  searchRequests,
  removeFee,
  getOrderDraftIdDetails,
  getOrderPaymentSummary,
  checkNewRequestEligibility,
  getCheckRemittance,
  confirmOrderDraftPayment,
  createOrdersFromDraft,
  bulkSendFax
};

export default DocumentRequestService;
